module.exports = __webpack_public_path__ + "static/servicios-primavera-20c7a5215ff45d9ec0460171d9a6efb5.png";